const FEATURE_HELP_URLS = {
  agent_bots: 'https://docs.shaiban.co/hc/agent-bots',
  agents: 'https://docs.shaiban.co/hc/agents',
  audit_logs: 'https://docs.shaiban.co/hc/audit-logs',
  campaigns: 'https://docs.shaiban.co/hc/campaigns',
  canned_responses: 'https://docs.shaiban.co/hc/canned',
  channel_email: 'https://docs.shaiban.co/hc/email',
  channel_facebook: 'https://docs.shaiban.co/hc/fb',
  custom_attributes: 'https://docs.shaiban.co/hc/custom-attributes',
  dashboard_apps: 'https://docs.shaiban.co/hc/dashboard-apps',
  help_center: 'https://docs.shaiban.co/hc/help-center',
  inboxes: 'https://docs.shaiban.co/hc/inboxes',
  integrations: 'https://docs.shaiban.co/hc/integrations',
  labels: 'https://docs.shaiban.co/hc/labels',
  macros: 'https://docs.shaiban.co/hc/macros',
  reports: 'https://docs.shaiban.co/hc/reports',
  sla: 'https://docs.shaiban.co/hc/sla',
  team_management: 'https://docs.shaiban.co/hc/teams',
  webhook: 'https://docs.shaiban.co/hc/webhooks',
  billing: 'https://docs.shaiban.co/pricing',
  saml: 'https://docs.shaiban.co/hc/saml',
  captain_billing: 'https://docs.shaiban.co/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
